import { Popover as ChakraPopover } from '@chakra-ui/react';
import type { PopoverProps as ChakraPopoverProps } from '@chakra-ui/react';

import { PopoverProvider } from './utils/PopoverContext';

export interface PopoverProps extends ChakraPopoverProps {
  hasArrow?: boolean;
}

export const Popover = ({
  size = 'md',
  hasArrow = true,
  children,
  ...restProps
}: PopoverProps) => {
  return (
    <PopoverProvider value={{ size, hasArrow }}>
      <ChakraPopover autoFocus size={size} {...restProps}>
        {children}
      </ChakraPopover>
    </PopoverProvider>
  );
};
